import {GET_OTP_REQUESTED, GET_OTP_SUCCESS, GET_OTP_FAILED} from "resources/actionTypes";

const initialState = {
  userOtp: [],
  loading: false,
  isAuth: false,
  error: null,
};

export default function userOtp(state = initialState, action) {
  switch (action.type) {
    case GET_OTP_REQUESTED:
      return {
        ...state,
        loading: true,
        isAuth:false,
      };
    case GET_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuth:true,
        userOtp: action.userOtp,
      };
    case GET_OTP_FAILED:
      return {
        ...state,
        loading: false,
        isAuth:false,
        error: action.message,
      };
    default:
      return state;
  }
}